import React, { useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import axios from "utils/axios";

const DemoForm = () => {
  const [thankYou, setThankYou] = useState(false);
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("Name is required")
      .matches(/^[a-zA-Z\s]*$/, "Name should contain only alphabets"),
    number: Yup.number()
      .typeError("Mobile number must be a number")
      .required("Mobile number is required")
      .test(
        "len",
        "Mobile number must be 10 digits",
        (val) => val && val.toString().length === 10
      ),
  });

  return (
    <section className="bg-[#222129]">
      <div className="max-w-6xl mx-auto">
        <div className="px-6 sm:px-10 md:px-16 lg:px-24 py-12 md:py-16 lg:py-20 flex flex-col lg:flex-row justify-center lg:space-x-12 space-y-10 lg:space-y-0 text-white">

          {/* Left Content */}
          <div className="text-center lg:text-left">
            <h4 className="font-semibold text-2xl sm:text-3xl lg:text-4xl">
              Ready to Work With the <br />
              <span className="text-[#FD6600]">Right Partner?</span>
            </h4>
            <p className="mt-3 text-sm sm:text-md text-gray-300">
              Tell us your details, we'll get back to you within 24 hours.
            </p>
          </div>

          {thankYou ? (
            <div className="w-full sm:w-3/4 md:w-2/3 lg:w-1/3 mx-auto lg:mx-0 bg-[#2c2b34] p-6 rounded-lg text-center">
              <h3 className="text-[#FD6600] text-xl font-semibold mb-3">
                Thank You!
              </h3>
              <p className="text-gray-300 text-sm">
                Your demo request has been submitted successfully.
                Our team will contact you shortly.
              </p>
            </div>
          ) : (
            <Formik
              initialValues={{
                name: "",
                number: "",
                interestShown: "Book a Demo",
              }}
              validationSchema={validationSchema}
              onSubmit={async (values, { resetForm }) => {
                setLoading(true);
                try {
                  const response = await axios.post(
                    "/api/auth/demo/request",
                    values
                  );

                  if (response.data.error === false) {
                    setThankYou(true);
                    resetForm();
                  }
                } catch (error) {
                  console.error("Error submitting form:", error);
                } finally {
                  setLoading(false);
                }
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                errors,
                touched,
              }) => (
                <form
                  className="space-y-6 w-full sm:w-3/4 md:w-2/3 lg:w-1/3 mx-auto lg:mx-0"
                  onSubmit={handleSubmit}
                >

                  {/* Name */}
                  <div>
                    <label className="text-sm font-semibold">
                      Full name <span className="text-[#FD6600]">*</span>
                    </label>
                    <input
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Full name"
                      className="w-full p-3 mt-2 rounded border border-gray-600 bg-transparent text-white"
                    />
                    {touched.name && errors.name && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.name}
                      </p>
                    )}
                  </div>

                  {/* Phone */}
                  <div>
                    <label className="text-sm font-semibold">
                      Phone Number <span className="text-[#FD6600]">*</span>
                    </label>
                    <input
                      name="number"
                      value={values.number}
                      onBlur={handleBlur}
                      onChange={(e) => {
                        const numericValue = e.target.value.replace(
                          /[^0-9]/g,
                          ""
                        );
                        handleChange({
                          target: { name: "number", value: numericValue },
                        });
                      }}
                      placeholder="10 digit number"
                      className="w-full p-3 mt-2 rounded border border-gray-600 bg-transparent text-white"
                    />
                    {touched.number && errors.number && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.number}
                      </p>
                    )}
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full sm:w-40 h-10 bg-[#ff6a00] rounded-md flex items-center justify-center text-sm text-white hover:bg-[#e55a00] transition disabled:opacity-50"
                  >
                    {loading ? "Submitting..." : "Request a callback"}
                  </button>
                </form>
              )}
            </Formik>
          )}
        </div>
      </div>
    </section>
  );
};

export default DemoForm;